<template>
  <div>
    <vs-tabs class="bg_filled_tab_holder" v-model="tabIndex">
      <vs-tab label="Today">
        <div
          class="
            table-responsive
            cstm_vuexy_table
            horizontal_scrollbar
            vertical_scrollbar
          "
          style="height: 150px; overflow: auto"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <table>
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Course Name</th>
                <th>Date</th>
                <th style="width: 220px">Attendance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in attendance_list" :key="index">
                <td>
                  {{ item.client_user.first_name }}
                  {{ item.client_user.last_name }}
                </td>
                <td>{{ item.course ? item.course.name : "" }}</td>
                <td>{{ item.schedule_date }}</td>
                <td>
                  <div class="flex flex-wrap items-center">
                    <ul class="inline-flex items-center attendance_ul">
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          v-model="item.attendance"
                          :vs-name="index"
                          :vs-value="true"
                          >Present</vs-radio
                        >
                      </li>
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          :vs-name="index"
                          v-model="item.attendance"
                          @change="markStudent(item)"
                          :vs-value="false"
                          >Absent</vs-radio
                        >
                      </li>
                    </ul>
                    <span
                      v-if="item.attendance == true"
                      style="font-size: 14px; cursor: pointer"
                      class="material-icons-outlined pl-2"
                      @click="edit_time(index)"
                      >edit</span
                    >
                    <p
                      class="cstm_badge warning mr-1"
                      v-if="item.attendance == true"
                    >
                      {{ item.delay_in_minutes }} minutes delay
                    </p>
                  </div>
                  <div class="inline-flex items-center mt-4">
                    <div
                      v-if="active_el == index"
                      class="delay_input_holder flex items-center"
                      :class="{ active: active_el == index }"
                    >
                      <vs-input
                        placeholder="Delay Time in minutes"
                        v-model="item.delay_in_minutes"
                        style="width: 150px"
                      />
                      <span
                        style="color: green; font-size: 18px; cursor: pointer"
                        class="material-icons-outlined ml-2"
                        @click="markStudent(item)"
                        >done</span
                      >
                      <span
                        style="color: red; font-size: 18px; cursor: pointer"
                        class="material-icons-outlined ml-2"
                        @click="active_el = null"
                        >clear</span
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-tab>
      <vs-tab label="This Week">
        <div
          class="
            table-responsive
            cstm_vuexy_table
            horizontal_scrollbar
            vertical_scrollbar
          "
          style="max-height: 150px; overflow: auto"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <table>
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Course Name</th>
                <th>Date</th>
                <th style="width: 220px">Attendance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in attendance_list" :key="index">
                <td>
                  {{ item.client_user.first_name }}
                  {{ item.client_user.last_name }}
                </td>
                <td>{{ item.course ? item.course.name : "" }}</td>
                <td>{{ item.schedule_date }}</td>
                <td>
                  <div class="flex flex-wrap items-center">
                    <ul class="inline-flex items-center attendance_ul">
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          :vs-name="index"
                          v-model="item.attendance"
                          :vs-value="true"
                          >Present</vs-radio
                        >
                      </li>
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          :vs-name="index"
                          v-model="item.attendance"
                          @change="markStudent(item)"
                          :vs-value="false"
                          >Absent</vs-radio
                        >
                      </li>
                    </ul>
                    <span
                      v-if="item.attendance == true"
                      style="font-size: 14px; cursor: pointer"
                      class="material-icons-outlined pl-2"
                      @click="edit_time(index)"
                      >edit</span
                    >
                    <p
                      class="cstm_badge warning mr-1"
                      v-if="item.attendance == true"
                    >
                      {{ item.delay_in_minutes }} minutes delay
                    </p>
                  </div>
                  <div class="inline-flex items-center mt-4">
                    <div
                      v-if="active_el == index"
                      class="delay_input_holder flex items-center"
                      :class="{ active: active_el == index }"
                    >
                      <vs-input
                        placeholder="Delay Time in minutes"
                        v-model="item.delay_in_minutes"
                        style="width: 150px"
                      />
                      <span
                        style="color: green; font-size: 18px; cursor: pointer"
                        class="material-icons-outlined ml-2"
                        @click="markStudent(item)"
                        >done</span
                      >
                      <span
                        style="color: red; font-size: 18px; cursor: pointer"
                        class="material-icons-outlined ml-2"
                        @click="active_el = null"
                        >clear</span
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-tab>
      <vs-tab label="This Month">
        <div
          class="
            table-responsive
            cstm_vuexy_table
            horizontal_scrollbar
            vertical_scrollbar
          "
          style="max-height: 150px; overflow: auto"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <table>
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Course Name</th>
                <th>Date</th>
                <th style="width: 220px">Attendance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in attendance_list" :key="index">
                <td>
                  {{ item.client_user.first_name }}
                  {{ item.client_user.last_name }}
                </td>
                <td>{{ item.course ? item.course.name : "" }}</td>
                <td>{{ item.schedule_date }}</td>
                <td>
                  <div class="flex flex-wrap items-center">
                    <ul class="inline-flex items-center attendance_ul">
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          :vs-name="index"
                          v-model="item.attendance"
                          :vs-value="true"
                          >Present</vs-radio
                        >
                      </li>
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          :vs-name="index"
                          v-model="item.attendance"
                          @change="markStudent(item)"
                          :vs-value="false"
                          >Absent</vs-radio
                        >
                      </li>
                    </ul>
                    <span
                      v-if="item.attendance == true"
                      style="font-size: 14px; cursor: pointer"
                      class="material-icons-outlined pl-2"
                      @click="edit_time(index)"
                      >edit</span
                    >
                    <p
                      class="cstm_badge warning mr-1"
                      v-if="item.attendance == true"
                    >
                      {{ item.delay_in_minutes }} minutes delay
                    </p>
                  </div>
                  <div class="inline-flex items-center mt-4">
                    <div
                      v-if="active_el == index"
                      class="delay_input_holder flex items-center"
                      :class="{ active: active_el == index }"
                    >
                      <vs-input
                        placeholder="Delay Time in minutes"
                        style="width: 150px"
                        v-model="item.delay_in_minutes"
                      />
                      <span
                        style="color: green; font-size: 18px; cursor: pointer"
                        class="material-icons-outlined ml-2"
                        @click="markStudent(item)"
                        >done</span
                      >
                      <span
                        style="color: red; font-size: 18px; cursor: pointer"
                        class="material-icons-outlined ml-2"
                        @click="active_el = null"
                        >clear</span
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
import { fetchStudentAttendance } from '@/api/dashboard.js'
import { markAttendence } from '@/api/calenderAction.js'
export default {
  data () {
    return {
      active_el: null,
      attendance: 'Present',
      openDelay: false,
      tabIndex: 0,
      attendance_list: [],
      customer_id: localStorage.getItem('customer_id'),
      attendance_meta: {
        current_page: 1,
        has_next: false,
        limit: 5,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }
    }
  },
  watch: {
    tabIndex () {
      this.active_el = null
      this.fetchAttendance()
    }
  },
  mounted () {
    this.fetchAttendance()
  },
  methods: {
    edit_time (index) {
      this.active_el = index
    },
    async markStudent (attendancedetails) {
      const payload = {
        course_id: attendancedetails.course_id,
        schedule_id: attendancedetails.id,
        unique_id: attendancedetails.unique_id,
        attendance_date: this.$moment(attendancedetails.schedule_date).format(
          'YYYY-MM-DD'
        ),
        clients: [
          {
            attendance: attendancedetails.attendance,
            delay_in_minutes: attendancedetails.delay_in_minutes,
            client_user_id: attendancedetails.id
          }
        ]
      }

      await markAttendence(this.customer_id, payload)
      this.active_el = null
      this.showSuccessMessage(
        'Success',
        'Student marked Successfully',
        'success'
      )
    },
    async fetchAttendance () {
      this.$vs.loading()
      this.attendance_meta.current_page = 1
      const payload = {
        dateRange: this.tabIndex + 1,
        limit: 5
      }
      const { data } = await fetchStudentAttendance(
        localStorage.getItem('customer_id'),
        payload,
        this.attendance_meta
      )
      this.attendance_list = data.data.students
      this.attendance_meta = data.data.meta
      this.$vs.loading.close()
    },
    detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight
      ) {
        this.loadMoreAttendance()
      }
    },
    async loadMoreAttendance () {
      this.attendance_meta.current_page += 1
      const payload = {
        dateRange: this.tabIndex + 1,
        limit: 5
      }
      const { data } = await fetchStudentAttendance(
        localStorage.getItem('customer_id'),
        payload,
        this.attendance_meta
      )
      this.attendance_list.push(...data.data.students)
      this.attendance_meta = data.data.meta
    }
  }
}
</script>